import { render, staticRenderFns } from "./ed-radio-button.vue?vue&type=template&id=35268a1e&scoped=true&"
import script from "./ed-radio-button.ts?vue&type=script&lang=ts&"
export * from "./ed-radio-button.ts?vue&type=script&lang=ts&"
import style0 from "./ed-radio-button.scss?vue&type=style&index=0&id=35268a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35268a1e",
  null
  
)

export default component.exports